var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerChatbubbles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.836 12.523c-.04-.14.047-.335.129-.476q.037-.063.082-.121a6.33 6.33 0 0 0 1.078-3.528c.012-3.601-3.027-6.523-6.785-6.523-3.277 0-6.012 2.23-6.652 5.191a6.3 6.3 0 0 0-.145 1.336c0 3.606 2.922 6.606 6.68 6.606.597 0 1.402-.18 1.843-.301s.88-.281.993-.324a1.03 1.03 0 0 1 .757.011l2.215.786q.074.03.153.039a.313.313 0 0 0 .312-.313.5.5 0 0 0-.02-.105z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.596 9.063a5.71 5.71 0 0 0 .25 5.963c.09.136.14.242.125.313-.016.07-.466 2.416-.466 2.416a.31.31 0 0 0 .106.3.32.32 0 0 0 .315.047l2.196-.86a.61.61 0 0 1 .469.008c.74.288 1.557.469 2.376.469a6.2 6.2 0 0 0 3.127-.84"
}))));
export default SvgIconOwnerChatbubbles;